// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 37.4rem) {
  .style_hide-sm__xtzQE {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__DAeXK {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__C6fno {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__UFXgl {
    display: none !important;
  }
}
/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.style_bodyWithSides__FTyfJ {
  display: flex;
  flex: 1 1 auto;
  padding: 0;
}
@media (max-width: 37.4rem) {
  .style_bodyWithSides__FTyfJ {
    flex-direction: column;
  }
}
@media (min-width: 37.4rem) {
  .style_sideBarRight__WYRvF {
    border-left: 0.0625rem solid var(--colorBorderTertiary);
  }
}
@media (min-width: 37.4rem) {
  .style_sideBarLeft__VWNod {
    border-right: 0.0625rem solid var(--colorBorderTertiary);
  }
}
.style_sidebarContainer__O74yA {
  flex-basis: 17.6rem;
}
.style_sideBar__Xm2Wm {
  font-size: 0.875rem;
}
@media (max-width: 37.4rem) {
  .style_sideBar__Xm2Wm {
    border-top: 0.0625rem solid var(--colorBorderTertiary);
  }
}
.style_sideBarPadding__zjol0 {
  padding: 0 1rem;
}
.style_main__yKnXp {
  flex-grow: 1;
  flex-basis: 1rem;
  min-width: 0;
}
@media (max-width: 37.4rem) {
  .style_main__yKnXp {
    flex-basis: auto;
  }
}
.style_overflowXHidden__Oap79 {
  overflow-x: hidden;
}
.style_mainContent__SjGw2 {
  padding-top: 0;
}
`, "",{"version":3,"sources":["webpack://./app/resources/styles/media.less","webpack://./app/components/SidebarLayout/style.less"],"names":[],"mappings":"AAMA;EACE;IACE,wBAAA;ECLF;AACF;ADQA;EACE;IACE,wBAAA;ECNF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;AACA;;;;;;;;;;;;EAYE;AA7BF;EACI,aAAA;EACA,cAAA;EAMA,UAAA;AA0BJ;AA9BI;EAAA;IACI,sBAAA;EAiCN;AACF;AA1BI;EAAA;IACI,uDAAA;EA6BN;AACF;AAzBI;EAAA;IACI,wDAAA;EA4BN;AACF;AAzBA;EACI,mBAAA;AA2BJ;AAxBA;EACI,mBAAA;AA0BJ;AAxBI;EAAA;IACI,sDAAA;EA2BN;AACF;AAxBA;EACI,eAAA;AA0BJ;AAvBA;EACI,YAAA;EACA,gBAAA;EAIA,YAAA;AAsBJ;AAnBI;EAAA;IACI,gBAAA;EAsBN;AACF;AAnBA;EAII,kBAAA;AAkBJ;AAfA;EACI,cAAA;AAiBJ","sourcesContent":["//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}","@import \"../../resources/styles/media\";\n@import \"../../resources/styles/colors\";\n\n.bodyWithSides {\n    display: flex;\n    flex: 1 1 auto;\n\n    @media (max-width: @screen-sm) {\n        flex-direction: column;\n    }\n\n    padding: 0;\n}\n\n@sideBarBorder: 0.0625rem solid @divider;\n.sideBarRight {\n    @media (min-width: @screen-sm) {\n        border-left: @sideBarBorder;\n    }\n}\n\n.sideBarLeft {\n    @media (min-width: @screen-sm) {\n        border-right: 0.0625rem solid @divider;\n    }\n}\n\n.sidebarContainer {\n    flex-basis: 17.6rem;\n}\n\n.sideBar {\n    font-size: 0.875rem;\n\n    @media (max-width: @screen-sm) {\n        border-top: @sideBarBorder;\n    }\n}\n\n.sideBarPadding {\n    padding: 0 1rem;\n}\n\n.main {\n    flex-grow: 1;\n    flex-basis: 1rem;\n\n    // https://www.w3.org/TR/css-flexbox-1/#min-size-auto\n    // This prevents the child from growing larger than the parent flexbox container if the childs content is large\n    min-width: 0;\n\n    // fixes ie11\n    @media (max-width: @screen-sm) {\n        flex-basis: auto;\n    }\n}\n\n.overflowXHidden {\n    // We shouldn't ever show extend outside of the main content and therefore should never require scroll bars\n    // This forces content to respect the width of the paper content div, and therefore internally show scrollbars etc. where required\n    // For example, horizontal scrollbars on the project overview when the filter panel is open and you have a lot of environments.\n    overflow-x: hidden;\n}\n\n.mainContent {\n    padding-top: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__xtzQE`,
	"hideSm": `style_hide-sm__xtzQE`,
	"visible-sm": `style_visible-sm__DAeXK`,
	"visibleSm": `style_visible-sm__DAeXK`,
	"hide-md": `style_hide-md__C6fno`,
	"hideMd": `style_hide-md__C6fno`,
	"visible-md": `style_visible-md__UFXgl`,
	"visibleMd": `style_visible-md__UFXgl`,
	"bodyWithSides": `style_bodyWithSides__FTyfJ`,
	"sideBarRight": `style_sideBarRight__WYRvF`,
	"sideBarLeft": `style_sideBarLeft__VWNod`,
	"sidebarContainer": `style_sidebarContainer__O74yA`,
	"sideBar": `style_sideBar__Xm2Wm`,
	"sideBarPadding": `style_sideBarPadding__zjol0`,
	"main": `style_main__yKnXp`,
	"overflowXHidden": `style_overflowXHidden__Oap79`,
	"mainContent": `style_mainContent__SjGw2`
};
module.exports = ___CSS_LOADER_EXPORT___;
